import { render, staticRenderFns } from "./CMSDetail.vue?vue&type=template&id=094af884&"
import script from "./CMSDetail.vue?vue&type=script&lang=js&"
export * from "./CMSDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports